import OrderOptimizerDetailsUpdateRequest, {
  OrderOptimizerDetailsUpdateRequestStatus,
} from "../../../../api/raily/order-optimizer/details/update/order-optimizer-details-update.request";
import OrderOptimizerDetailsUpdateParams, {
  OrderOptimizerDetailsUpdateParamsStatus,
} from "./order-optimizer-details-update-params";

const createStatus = (
  status: OrderOptimizerDetailsUpdateParamsStatus | undefined,
): OrderOptimizerDetailsUpdateRequestStatus | undefined => {
  switch (status) {
    case OrderOptimizerDetailsUpdateParamsStatus.INTERESTING:
      return OrderOptimizerDetailsUpdateRequestStatus.INTERESTING;
    case OrderOptimizerDetailsUpdateParamsStatus.PENDING:
      return OrderOptimizerDetailsUpdateRequestStatus.PENDING;
    case OrderOptimizerDetailsUpdateParamsStatus.REJECTED:
      return OrderOptimizerDetailsUpdateRequestStatus.REJECTED;
    default:
      return undefined;
  }
};

const create = (
  params: OrderOptimizerDetailsUpdateParams,
): OrderOptimizerDetailsUpdateRequest => {
  return {
    id: params.id,
    status: createStatus(params.status),
  };
};

const orderOptimizerDetailsUpdateParamsFactory = {
  create,
};

export default orderOptimizerDetailsUpdateParamsFactory;
